// PairingCodeDisplay — 配对码展示
// 将 6 位房间码大字号展示，配合可选 PIN，供他端手动输入

import { useToastStore } from '../common/Toast';

interface PairingCodeDisplayProps {
  code: string;
  pin?: string;
  onClose: () => void;
}

export function PairingCodeDisplay({ code, pin, onClose }: PairingCodeDisplayProps) {
  const toast = useToastStore((s) => s.show);
  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(code);
      toast('配对码已复制', 'success');
    } catch {
      toast('复制失败', 'error');
    }
  };

  // 分字符展示，便于辨识
  const chars = code.split('');

  return (
    <div className="card p-6 max-w-sm w-full text-center animate-slide-up">
      <h3 className="text-lg font-bold text-ink mb-1">配对码</h3>
      <p className="text-xs text-muted mb-5">在另一台设备输入以下 6 位码加入</p>

      <div className="flex justify-center gap-1.5 mb-2">
        {chars.map((ch, i) => (
          <span
            key={i}
            className="w-11 h-14 flex items-center justify-center rounded-md bg-primary text-primary-fg text-2xl font-bold shadow-btn"
          >
            {ch}
          </span>
        ))}
      </div>
      <button
        type="button"
        onClick={copyCode}
        className="text-xs text-muted hover:text-primary transition-colors"
      >
        点击复制配对码
      </button>

      {pin && (
        <div className="mt-5 rounded-md bg-warning/10 border border-warning/30 px-4 py-3">
          <p className="text-xs text-muted">连接时需输入 PIN</p>
          <p className="text-2xl font-bold tracking-[0.3em] text-ink mt-1">{pin}</p>
        </div>
      )}

      <div className="mt-5">
        <button type="button" onClick={onClose} className="btn-ghost w-full">
          关闭
        </button>
      </div>
    </div>
  );
}
